import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Order } from './order.model';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { IResultWithPageInfo } from '../app-store.interfaces';

const httpOptions = {
    headers: new HttpHeaders({
        ContentType: 'application/json',
        Accept: 'application/json',
    }),
};

@Injectable({ providedIn: 'root' })
export class OrderService {
    constructor(private http: HttpClient) {}

    loadPage(pageNumber: number, pageSize: number): Observable<IResultWithPageInfo<Order>> {
        return this.http
            .get<any>(
                `${environment.rootUrl}/order?pageNumber=${pageNumber}&pageSize=${pageSize}`,
                httpOptions
            )
            .pipe(
                map((response) => ({
                    entities: response.items as Order[],
                    pageInfo: {
                        page: { pageNumber: response.pageIndex, pageSize },
                        totalCount: response.totalCount,
                    },
                }))
            );
    }

    loadPageByCategories(
        pageNumber: number,
        pageSize: number,
        categoryIds: number[],
        searchValue?: string
    ): Observable<IResultWithPageInfo<Order>> {
        let params = new HttpParams()
            .set('pageNumber', pageNumber.toString())
            .set('pageSize', pageSize.toString());

        for (const id of categoryIds) {
            params = params.append('categoryIds', id.toString());
        }

        if (searchValue) {
            params = params.set('searchValue', searchValue);
        }

        return this.http
            .get<any>(`${environment.rootUrl}/order`, { ...httpOptions, params })
            .pipe(
                map((response) => ({
                    entities: response.items as Order[],
                    pageInfo: {
                        page: { pageNumber: response.pageIndex, pageSize },
                        totalCount: response.totalCount,
                    },
                }))
            );
    }

    loadSingle(id: number): Observable<Order> {
        return this.http.get<Order>(`${environment.rootUrl}/order/${id}`, httpOptions);
    }
}
